import { ComponentProps } from 'react';
import { TestimonialsCarousel } from '@belong/ui';

export const TestimonialsCarouselSlice = (
  props: ComponentProps<typeof TestimonialsCarousel>,
) => {
  return (
    <div className="carousel-container flex justify-center">
      <TestimonialsCarousel {...props} />
    </div>
  );
};
